import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'trqk-mark';

const originalDimensions = {
    width: 94,
    height: 94,
};

export const IconTrqkMark = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'primary-500';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            height={height}
            id="Layer_1"
            version="1.1"
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
        >
            <title id={iconId}>
                Icon of audio waveform shown as vertical bars
            </title>
            <path
                fill={fill}
                d="M5.7 20.6c-3.1 0-5.6 2.5-5.7 5.6v41.6c0 3.1 2.5 5.6 5.6 5.6 3.1 0 5.6-2.5 5.6-5.6V26.2c.1-3-2.4-5.6-5.5-5.6zM22.1 26.9c-3.1 0-5.6 2.5-5.7 5.6v29c0 3.1 2.5 5.6 5.6 5.6 3.1 0 5.6-2.5 5.6-5.6v-29c.1-3.1-2.4-5.6-5.5-5.6zM38.5 14.3c-3.1 0-5.6 2.5-5.6 5.6V74.1c0 3.1 2.5 5.6 5.6 5.6 3.1 0 5.6-2.5 5.6-5.6V19.9c.1-3-2.5-5.6-5.6-5.6zM55 0c-3.1 0-5.6 2.5-5.6 5.6l-.1 41.2v.4l.1 41.2c0 3.1 2.5 5.6 5.6 5.6 3.1 0 5.6-2.5 5.6-5.7L60.5 47l.1-41.4C60.6 2.5 58.1 0 55 0zM71.4 27.6c-3.1 0-5.6 2.5-5.7 5.6V61c0 3.1 2.5 5.6 5.6 5.6 3.1 0 5.6-2.5 5.6-5.6l.1-14V33.2c0-3.1-2.5-5.6-5.6-5.6zM93.3 19.6c0-3.1-2.5-5.6-5.6-5.6-3.1 0-5.6 2.5-5.6 5.6v54.8c0 3.1 2.5 5.6 5.6 5.6 3.1 0 5.6-2.5 5.6-5.6V19.6z"
            />
        </svg>
    );
};
